import React, { useRef } from 'react';
import classNames from 'classnames';

import { ButtonProps } from '@mui/material/Button';
import Popover from '@mui/material/Popover';

import classes from './HeaderToolbar.scss';

type ButtonWithPopoverProps = React.PropsWithChildren<{
  popoverContent?: React.ReactElement
  popoverContentRenderer?: (props: { onClose: ButtonProps['onClick'] }) => React.ReactElement
}>

export default function ButtonWithPopover({
  children,
  popoverContent,
  popoverContentRenderer,
}: ButtonWithPopoverProps) {
  const refEl = useRef()
  const [anchorEl, setAnchorEl] = React.useState<HTMLSpanElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <span
        ref={refEl}
        onClick={handleClick}
        className={classNames(classes.item, classes.dropdownItem, {
          [classes.dropdownItemOpen]: !!anchorEl
        })}
      >
        {children}
      </span>
      <Popover
        open={!!anchorEl}
        anchorEl={refEl.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
        sx={{
          '.MuiPopover-paper': {
            boxShadow: 'rgba(0, 0, 0, 0.3) 0px 19px 60px, rgba(0, 0, 0, 0.22) 0px 15px 20px',
            overflow: 'initial',

            ':before': {
              content: `''`,
              position: 'absolute',
              top: '-6px',
              right: '10%',
              width: '0',
              height: '0',
              borderStyle: 'solid',
              borderWidth: '0 8px 6px 8px',
              borderColor: 'transparent transparent #ffffff transparent',
            },
          },
        }}
      >
        {popoverContent}
        {popoverContentRenderer?.({ onClose: handleClose })}
      </Popover >
    </>
  )
}
